import type { PropsWithChildren } from 'react'

import LandingFooter from './landing-footer'
import LandingHeader from './landing-header'

const LandingLayout: React.FC<PropsWithChildren> = ({ children }) => {
    return (
        <div className="">
            <LandingHeader />
            {children}
            <LandingFooter />
        </div>
    )
}

export default LandingLayout
